import { render, staticRenderFns } from "./D_F7.vue?vue&type=template&id=70b98c52&scoped=true"
import script from "./D_F7.vue?vue&type=script&lang=js"
export * from "./D_F7.vue?vue&type=script&lang=js"
import style0 from "./D_F7.vue?vue&type=style&index=0&id=70b98c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b98c52",
  null
  
)

export default component.exports